<template>
    <div class="footer-text">
        {{ text }}
    </div>
</template>
<script>
export default{
    name: 'FooterText',
    props: {
        text: String
    }
}
</script>